import { TextInput, TextInputProps } from 'react-admin';

type CGTextInputProps = TextInputProps & {
  autoComplete?: string;
};

const XTextInput = (props: CGTextInputProps) => {
  const { autoComplete = 'off' } = props;
  return <TextInput autoComplete={autoComplete} {...props} />;
};

export default XTextInput;
